export enum ConcurrentRequestHandlingEnum {
    FirstOnly,
    AllowAll,
    LastOnly
}